import React, { useEffect } from 'react'
import style from "./sidebarPage.module.scss"
import Sidebar from '../Components/sidebar/sidebar'
import MobileNavBar from "../Components/mobileNavbar/navbar"
import style2 from "./guide.module.scss"
import { CompleteProgressBar, GetProgressBar } from '../actions/APIcalls'

const Links = [
    { title: 'ثبت پنل', link: "https://www.aparat.com/video/video/embed/videohash/EM3Vr/vt/frame?titleShow=true&recom=self" },
    { title: 'قیمت‌گذاری تنوع‌ها', link: "https://www.aparat.com/video/video/embed/videohash/qPEHW/vt/frame?titleShow=true&recom=self" },
    { title: 'بروزرسانی‌های پنل', link: "https://www.aparat.com/video/video/embed/videohash/tiyb791/vt/frame?titleShow=true&recom=self" },
    { title: 'قیمت‌گذاری تنوع‌ها توسط فایل اکسل (جدید)', link: "https://www.aparat.com/video/video/embed/videohash/tav7165/vt/frame?titleShow=true&recom=self" },
    { title: 'خطای "کف قیمت"', link: "https://www.aparat.com/video/video/embed/videohash/ijcwy0y/vt/frame?titleShow=true&recom=self" },
    { title: 'خطای "تخفیف هوشمند"', link: "https://www.aparat.com/video/video/embed/videohash/pdzlx6z/vt/frame?titleShow=true&recom=self" },
    { title: 'خطای "بازه قیمت مرجع "', link: "https://www.aparat.com/video/video/embed/videohash/mfa9uca/vt/frame?titleShow=true&recom=self" },
    { title: 'خطا "از سمت دیجی‌کالا"', link: "https://www.aparat.com/video/video/embed/videohash/jku347t/vt/frame?titleShow=true&recom=self" },
    { title: "محموله‌سازی", link: "https://www.aparat.com/video/video/embed/videohash/bhpl8v0/vt/frame?titleShow=true&recom=self" },
    { title: 'کنترل موجودی', link: "https://www.aparat.com/video/video/embed/videohash/wcKOZ/vt/frame?titleShow=true&recom=self" },
    { title: 'قیمت‌گذاری تنوع‌ها توسط فایل اکسل (قدیمی)', link: "https://www.aparat.com/video/video/embed/videohash/dPNL8/vt/frame?titleShow=true&recom=self" },
]

const Guide = (props) => {

    useEffect(async () => {
        // complete progressBar
        await handleProgressBar()
        // complete progressBar
    }, [])

    const handleProgressBar = async () => {
        let local = localStorage.getItem('progressBar')
        if (typeof local !== 'undefined' && local != null) {
            let res = await GetProgressBar()
            if (res && res.data && res.data.success) {
                let tmpLocal = res.data.progressData.progressBar
                if (!tmpLocal.Guide) {
                    await CompleteProgressBar({ stage: 'Guide' })
                }
            }
        }
    }

    return (
        <div className={style.wrapper}>
            <div className={style.mobileNavBar}>
                <MobileNavBar />
            </div>
            <div className={style.content}>
                <h3>ویدیوهای آموزشی</h3>
                <div className={style2.container}>
                    {Links.map((item, index) => {
                        return <div className={style2.wrap}>
                            <h4>{item.title}</h4>
                            <div className={style2.videoFrame}>
                                <iframe
                                    width="100%"
                                    height="100%"
                                    src={item.link}
                                    frameBorder="0"
                                    allowFullScreen="true"
                                    webkitallowfullscreen="true"
                                    mozallowfullscreen="true"
                                    title="Embedded youtube"
                                    style={{ border: '0', MozBorderRadius: '8px', borderRadius: '8px', }}
                                />
                            </div>
                        </div>
                    })}
                </div>
            </div>
            <div className={style.sidebar}>
                <Sidebar user={props.user} />

            </div>
        </div>
    )
}
export default Guide